var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.105 12.395a3.8 3.8 0 0 0 3.79-3.802 3.8 3.8 0 0 0-3.79-3.802 3.8 3.8 0 0 0-3.79 3.802 3.8 3.8 0 0 0 3.79 3.802Zm1.421.951H8.684C5.55 13.346 3 15.904 3 19.049V20h14.21v-.95c0-3.146-2.549-5.704-5.684-5.704Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.835 11.49a5.405 5.405 0 0 0 .712-3.27c-.17-1.695-1.113-3.194-2.656-4.22l-1.046 1.584c1.06.705 1.705 1.71 1.817 2.827a3.522 3.522 0 0 1-1.016 2.838l-1.13 1.133 1.534.452c4.009 1.178 4.055 5.224 4.055 5.265H21c0-1.7-.906-5.024-4.165-6.608Z"
  })));
};
export default SvgGroup;